"use client";

import { useState } from "react";
import { UseFastBuyProps } from "../ongs.types";

export function useFastBuy({ skus }: UseFastBuyProps) {
  const [showAddToCart, setShowAddToCart] = useState(true);
  const [counter, setCounter] = useState(1);
  const [loading, setLoading] = useState(false);
  const [firstClick, setFirstClick] = useState(false);

  const renderSliderSkus = skus && skus.length > 0;

  return {
    counter,
    loading,
    firstClick,
    showAddToCart,
    renderSliderSkus,
    setCounter,
    setLoading,
    setFirstClick,
    setShowAddToCart
  };
}
